/**
 * @file SupportPage.jsx
 * @description Standalone public support page, rendered at /support and
 *   accessible to all roles including guests — for use as a direct link
 *   (e.g. Stripe's "Support URL" business-info field) that doesn't require
 *   navigating the app first. Reuses ContactModal as-is (same public,
 *   Turnstile-protected contact form used from the footer and agency
 *   landing page) rather than duplicating the form.
 * @author Victor Carpinelli
 * @version 1.0.0
 * @module components/SupportPage
 */
import { usePageSeo } from "../lib/seo";
import ContactModal from "./ContactModal";

export default function SupportPage({ onBack }) {
  usePageSeo({ title: "Support | ABAcases", canonical: "/support", noindex: true });

  return <ContactModal onClose={onBack} />;
}
